import * as React from 'react';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

function BankAccount({iban, balance}) {
    return (
        <div style={{marginBottom: '1em'}}>
            <AccountBalanceWalletIcon style={{float: 'left', margin: '0.4em 0.6em'}}/>
            <div style={{fontSize: '120%', fontWeight: 'bold', float: 'right'}}>
                {(balance / 100).toFixed(2).replace(".", ",").replace(
                    /(\d)(?=(\d{3})+(?!\d))/g, '$1.')} €
            </div>
            <div style={{fontSize: '120%', fontWeight: 'bold'}}>Girokonto</div>
            <div style={{fontSize: '90%', opacity: '75%'}}>{iban}</div>
        </div>
    )
}

export default BankAccount;